import request from './api'
/**
 *    sourceApi   素材库api
 * */

/**
 * @author zz 2020.04.03
 * @description 获取素材库左侧目录树
 */
export const getMaterialTreeList = (params, opts) =>
    request('/api-resource/cjdd-resources/resourses/get/material/catalog', params, opts);

// /**
//  * @author zz 2020.04.03
//  * @description 添加树形节点
//  */
// export const addMaterialTreeNode = (params, opts) =>
//     request(process.env.VUE_APP_URL + '/api-resource/cjdd-resources/resourses/insert/material/node', params, opts);
//
// /**
//  * @author zz 2020.04.03
//  * @description 更新树节点名称
//  */
// export const updateMaterialTreeNode = (params, opts) =>
//     request(process.env.VUE_APP_URL + '/api-resource/cjdd-resources/resourses/update/material/node', params, opts);
//
// /**
//  * @author zz 2020.04.03
//  * @description 删除树节点名称
//  */
// //TODO 不会封装删除方法
// export const deleteMaterialTreeNode = (params, opts) =>
//     request(process.env.VUE_APP_URL + '/api-resource/cjdd-resources/resourses/delete/material/node', params, opts);



/**
 * @author zz 2020.04.03
 * @description 移动树节点名称
 */
export const moveMaterialTreeNode = (params, opts) =>
    request('/api-resource/cjdd-resources/resourses/catalog', params, opts);

/**
 * @author zz 2020.04.03
 * @description 获取素材详细情况
 */
export const getMaterial = (params, opts) =>
    request('/api-resource/cjdd-resources/resourses/get/material/catalog/',params, opts);

/**
 * @author zz 2020.04.06
 * @description 预览zip
 */
export const previewZip = (params, opts) =>
    request('/file/doesObjectExistZip',params, opts);
/**
 * @author zz 2020.04.06
 * @description 获取附件列表
 */
export const getAttachementList = (params, opts) =>
    request('/api-resource/cjdd-resources/resourses/get/material/attachment/audit/lists', params, opts);
/**
 * @author zz 2020.04.06
 * @description 确认开放
 */
export const confirmOpenMaterial = (params, opts) =>
    request('/api-resource/cjdd-resources/resourses/is/open/material/attachment', params, opts);
/**
 * @author zz 2020.04.07
 * @description 素材列表查看
 */
export const getMaterialDetail = (params, opts) =>
    request('/api-resource/cjdd-resources/resourses/get/material/attachment/one', params, opts);
export const getMaterialDetailNoAuth = (params, opts) =>
  request('/api-resource/cjdd-resources/resourses/get/material/attachment/one/noAuth', params, opts);

/**
 * @author zz 2020.04.07
 * @description 素材列表查看
 */
export const editImageTextlDetail = (params) =>
  request('/api-resource/cjdd-resources/updateAttachment', params, { method: "post" });
/**
 * @author zz 2020.04.07
 * @description 修改素材附件
 */
export const updateMateria = (params, opts) =>
    request('/api-resource/cjdd-resources/resourses/update/material/attachment/one', params, opts);
/**
 * @author zz 2020.04.07
 * @description 删除素材附件
 */
export const deleteMaterial = (params, opts) =>
    request('/api-resource/cjdd-resources/resourses/delete/material/attachment/one', params, opts);

//根据课程id获取课程信息
export const getCourseInfo = (id, params, opts) => request("/api-course/course/"+id, params, opts);

/**
 * @author
 * @description 目录，添加资源，保存接口
 */
export const submitMaterialBtn = (params, opts) => request("/api-course/catalog/add/material", params, { ...opts, method: "post" });

/**
 * @author
 * @description 目录，添加资源，修改接口
 */
export const updateCatalogMaterial = (params, opts) => request("/api-course/catalog/update/material", params, { ...opts, method: "post" });


/**
 * @author wjl 2021.8.26
 * @description 修改tagName
 */
export const postEidtorTagName = (params) => request("/api-course/catalog/update/tagName", params, { method: "post" });

/**
 * @author wjl 2021.8.26
 * @description 保存图文，保存富文本
 */
export const postAddImageText = (params) => request("/api-course/categoryResource/add/imageText", params, { method: "post" });
/**
 * @author wjl 2021.8.26
 * @description 修改图文，修改富文本
 */
export const postUpdateImageText = (params) => request("/api-course/categoryResource/update/imageText", params, { method: "post" });


/**
 * @author zz 2021.08.19
 * @description 获取素材库左侧目录树
 */
export const getMaterialTreeListById = (params, opts) =>
  request('/api-resource/cjdd-resources/resourses/get/material/catalog/'+params,{}, opts);
/**
 * @author zz 2023.02.16
 * @description 获取素材库授权科目
 */
export const findSubjectList = (params, opts) =>
  request('/api-resource/subjectType/findSubjectList', params, { ...opts, method: 'post' });
//查询当前用户可用的科目
export const getSubjectData = (params, opts) => request("/api-resource/cjdd-resources/currentUserPermission/subjects", params, opts);
//根据课程id获 获取该专业下的课程
export const getCourseList = (params, opts) => request("/api-course/course/querySameProfession", params, opts);
/**
 * @author zz 2021.08.19
 * @description 添加文件获取素材列表
 */
export const getMaterialList = (params, opts) =>
  request('/api-resource/cjdd-resources/resourses/get/material/attachment/lists', params, opts)
/**
 * @author zz 2021.08.19
 * @description 新添加文件获取素材列表
 */
export const newGetMaterialList = (params, opts) =>
  request('/api-resource/cjdd-resources/resourses/getResourceAttachmentList', params, opts)

/**
 * @author zz 2021.08.21
 * @description 素材列表
 */
export const getResourceList = (params, opts) =>
  request('/api-course/categoryResource/findPage/resource', params, opts);
/**
 * @author zz 2021.08.19
 * @description 根据课程id查询资源分类
 */
export const FindResCategoryByCourseId = (params, opts) =>
  request(`/api-course/categoryResource/findResCategoryByCourseId?courseId=${params}`, opts);

/**
 * @author zz 2021.08.21
 * @description 课程库保存资源接口
 */
export const saveResourceBtn = (params, opts) =>
  request('/api-course/categoryResource/add/resource', params, {method: 'post'});

/**
 * @author wjl 2021.08.23
 * @description 根据课程id查询素材
 */
export const getResoureceByCourseId = (params) =>
  request('/api-course/categoryResource/findCategoryResourceByCourseId',params, {method: "post"});

/**
 * @author zz 2021.08.23
 * @description 删除 和批量删除
 */
export const deleteResource = (params, opts) =>
request('/api-course/categoryResource/delete/resource', params, {method: 'post'});

/**
 * @author zz 2021.08.25
 * @description 资源批量开启或关闭下载接口
 */
export const downloadResource = (params, opts) =>
  request('/api-course/categoryResource/download/resource', params, {method: 'post'});
/**
 * @author zz 2021.08.25
 * @description 资源排序接口
 */
export const sortResource = (params, opts) =>
  request('/api-course/categoryResource/sort/resource', params, {method: 'post'});
/**
 * @author zz 2021.08.25
 * @description 资源排序接口
 */
export const questionSort = (params, opts) =>
  request('/api-course/catalog/update/questionSort', params, {method: 'post'});

/**
 * @author zz 2022.03.21
 * @description 获取章节树
 */
// 获取章节树
export const newGetCourseCatalog = (id, type, params, opts) => request(`/api-course/catalog/catalogByType/${id}/${type}`, params, opts);
// export const newGetCourseCatalogTwo = (id, type, classId, params, opts) => request(`/api-course/catalog/catalogByType/${id}/${type}/${classId}`, params, opts);
export const newGetCourseCatalogTwo =  (params, opts) =>
request('/api-course/catalog/catalogByType', params, {method: 'post'});

/**
 * @author zz 2022.03.25
 * @description 获取章节树全部数据
 */
// 获取章节树全部数据
export const findAllResourceByCourseId = (courseId, opts) => request(`/api-course/catalog/findAllResourceByCourseId/${courseId}`);
export const findAllResourceByCourseIdTwo = (params, opts) =>
request('/api-course/catalog/findAllResourceByCourseId', params, {method: 'post'});



/**
 * @author zz 2021.08.28
 * @description 添加链接
 */
export const categoryResourceAddLink = (params, opts) =>
  request('/api-course/categoryResource/add/link', params, {
    ...opts,
    method: 'post'
  });
/**
 * @author zz 2021.08.28
 * @description 编辑实训专用保存
 */
export const addQuestion = (params, opts) =>
  request('/api-course/catalog/add/question', params, {
    ...opts,
    method: 'post'
  });
/**
 * @author zz 2021.08.28
 * @description 修改链接
 */
export const categoryResourceUpdateLink = (params, opts) =>
  request('/api-course/categoryResource/update/link', params, {
    ...opts,
    method: 'post'
  });

/**
 * @author wjl 2021.12.16
 * @description 图文关联一道试题
 */
export const editResourceQuestion = (params) =>
  request('/api-resource/resourceQuestion/editResourceQuestion', params, {
    method: 'post'
  });
/**
 * @author wjl 2021.12.16
 * @description 图文关联一道试题
 */
export const getResourceQuestion = (id, params) =>
  request('/api-resource/resourceQuestion/queryResourceQuestion/'+ id, params);

/**
 * @author wjl 2021.12.16
 * @description 图文关联一道试题
 */
export const updateResourceName = (params) =>
  request('/api-course/categoryResource/updateName', params, {  method: 'post' });
// 根据科目查询是否有资源库权限 >>新加
export const getPermission = (params, opts) =>
  request(`/api-resource/cjdd-resources/teacher/subject/permission/${params}`, opts);






// WEBPACK FOOTER //
// ./src/api/sourceApi.js